import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";
import { useLocation, Location } from "react-router-dom";

export const useAppDispatch: () => AppDispatch = () =>
    useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppLocation = (): Location => useLocation();
